import Product from 'cpc-license-manager/models/product';
import { belongsTo } from '@ember-data/model';

class Analytics extends Product {
  @belongsTo('analytics-feature', { async: false, inverse: null, embedded: true }) features;

  name = 'analytics';
  label = 'Analytics';

  get featuresJson() {
    return {
      numberOfDashboards: this.features.numberOfDashboards,
    };
  }
}

export default Analytics;
